export const APPLY_FILTERS = 'APPLY_FILTERS';

export const screenReducerWithAnalyticsAdapter =
  (originReducer) => (state, action) => {
    switch (action.type) {
      case APPLY_FILTERS:
        break;
    }
    return originReducer(state, action);
  };
